import React from 'react';
import { useTranslation } from 'react-i18next';

const SuccessUpload = ({ onBackToList }) => {
  const { t } = useTranslation('bulkproducts');
  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      {/* Success Animation/Icon */}
      <div className="mb-8">
        {/* show gif  */}
        <img
          src="/success-mark.gif"
          alt="Success"
          className="mx-auto w-64 h-64"
        />
      </div>

      {/* Success Message */}
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          {t('success.title')}
        </h2>
        <p className="text-gray-600">
          {t('success.description')}
        </p>
      </div>

      {/* Action Button */}
      <button
        onClick={onBackToList}
        className="w-[246.5px] px-[8px] py-[12px] bg-[#6609F8] text-[#F4F1FF] rounded-[8px] hover:bg-[#6609F8] transition-colors font-[700]"
      >
        {t('success.backToList')}
      </button>
    </div>
  );
};

export default SuccessUpload;